module.exports = __webpack_public_path__ + "static/media/header-background.aaa019f3.jpg";